module.exports = __webpack_public_path__ + "static/homepage-mobile-diaboutique-bf161fa73134ef9e747984b5bc567d84.jpg";